"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapFooter = function mapFooter(response) {
  var _response$data$rights, _response$data$social;
  if (!response || response.type !== global.__appConfig__.prismicPrefix + "footer") return;
  var footer = {};
  footer.columns = [];
  var footerColumns = ["footer1", "footer2", "footer3", "footer4"];
  footerColumns === null || footerColumns === void 0 ? void 0 : footerColumns.map(function (column) {
    var columnPart = {};
    columnPart.items = [];
    if (column === "footer4") {
      var _response$data$column;
      columnPart.title = response.data[column] && response.data[column][0].text;
      columnPart.content = (_response$data$column = response.data[column]) === null || _response$data$column === void 0 ? void 0 : _response$data$column.slice(1);
    } else {
      var _response$data$column2;
      (_response$data$column2 = response.data[column]) === null || _response$data$column2 === void 0 ? void 0 : _response$data$column2.map(function (columnData) {
        if (columnData.type === "paragraph") {
          columnPart.title = columnData.text;
        }
        if (columnData.type === "list-item") {
          var _columnData$spans$0$d;
          columnPart.items.push({
            text: columnData.text,
            url: columnData.spans && (_columnData$spans$0$d = columnData.spans[0].data) !== null && _columnData$spans$0$d !== void 0 && _columnData$spans$0$d.url ? columnData.spans[0].data.url.replace("https:/", "") : "/"
          });
        }
      });
    }
    footer.columns.push(columnPart);
  });
  footer.rights = {};
  footer.rights.items = [];
  response.data.rights && ((_response$data$rights = response.data.rights) === null || _response$data$rights === void 0 ? void 0 : _response$data$rights.map(function (rightsData) {
    if (rightsData.type === "paragraph") {
      footer.rights.text = rightsData.text;
    }
    if (rightsData.type === "list-item") {
      var _rightsData$spans$0$d;
      footer.rights.items.push({
        text: rightsData.text,
        url: rightsData.spans && rightsData.spans && (_rightsData$spans$0$d = rightsData.spans[0].data) !== null && _rightsData$spans$0$d !== void 0 && _rightsData$spans$0$d.url ? rightsData.spans[0].data.url.replace("https:/", "") : "/"
      });
    }
  }));
  footer.social = [];
  response.data.social && ((_response$data$social = response.data.social) === null || _response$data$social === void 0 ? void 0 : _response$data$social.map(function (socialData) {
    if (socialData.type === "list-item") {
      footer.social.push({
        text: socialData.text,
        url: socialData.spans && socialData.spans[0].data.url
      });
    }
  }));
  return footer;
};
var _default = mapFooter;
exports["default"] = _default;